export default "__VITE_ASSET__CqoK1_6c__"